import React, { useMemo } from "react";
import cn from "classnames";

import FilterDatePicker from "components/datePicker/FilterDatePicker";

import "./filterDateRange.scss";
import { type GenericFiltersMap, type RangeFilterValues } from "utils/filterUtils";

interface FilterDateRangeProps<T extends string> {
  propertyName: T;
  label?: string;
  filter: GenericFiltersMap<T>;
  updateFilter: (filter: GenericFiltersMap<T>) => void;
  verticalPosition?: string;
  horizontalPositionFirstPicker?: string;
  horizontalPositionSecondPicker?: string;
  className?: string;
  disabled?: boolean;
}

function FilterDateRange<T extends string>({
  label,
  propertyName,
  filter,
  updateFilter,
  className,
  disabled,
  verticalPosition,
  horizontalPositionFirstPicker,
  horizontalPositionSecondPicker,
}: FilterDateRangeProps<T>) {
  const rangeValue = useMemo((): RangeFilterValues => {
    const filterValue: unknown = filter[propertyName];

    if (filterValue && typeof filterValue === "object" && ("from" in filterValue || "to" in filterValue)) {
      return filterValue as RangeFilterValues;
    }

    return { from: "", to: "" };
  }, [filter, propertyName]);

  return (
    <div className={cn("filter-date-range", className)}>
      {label && <div className="label">{label}</div>}
      <div className="bottom-row">
        <FilterDatePicker
          placeholder="From"
          propertyName={propertyName}
          filter={filter}
          updateFilter={updateFilter}
          disabled={disabled}
          verticalPosition={verticalPosition}
          horizontalPosition={horizontalPositionFirstPicker}
          maxDate={rangeValue.to}
        />
        <span className="delimiter">-</span>
        <FilterDatePicker
          placeholder="To"
          propertyName={propertyName}
          filter={filter}
          updateFilter={updateFilter}
          disabled={disabled}
          verticalPosition={verticalPosition}
          horizontalPosition={horizontalPositionSecondPicker}
          popupPosition="bottom right"
          minDate={rangeValue.from}
        />
      </div>
    </div>
  );
}

export default FilterDateRange;
